import { vec2 } from "gl-matrix";
import { GeometryUtils as G } from "../utils/Geometry.js";
export { Port };
class Port {
    constructor({ position, direction }) {
        this.position = position;
        this.direction = direction;
    }
    leftOffset(offset) {
        const left = G.leftOrthogonal(this.direction);
        const factor = offset / vec2.length(left);
        return [this.position[0] + left[0] * factor, this.position[1] + left[1] * factor];
    }
    rightOffset(offset) {
        const left = G.rightOrthogonal(this.direction);
        const factor = offset / vec2.length(left);
        return [this.position[0] + left[0] * factor, this.position[1] + left[1] * factor];
    }
}
//# sourceMappingURL=Port.js.map